import { Injectable } from '@angular/core';
import {LoadingController} from "@ionic/angular/standalone";
import {from} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  loading: HTMLIonLoadingElement | undefined;
  private isLoading = false;
  /**
   * Avanza a ogni `hideLoader()`. `loadingCtrl.create()` è asincrono: se la chiusura arriva mentre
   * il loader è ancora in creazione (chiamante che non attende `showLoader`, risposta HTTP più
   * veloce dell'overlay) non c'è nulla da chiudere, e il loader creato dopo resterebbe a schermo
   * per sempre. Chi ha aperto confronta la propria generazione e, se è cambiata, non lo presenta.
   */
  private generazione = 0;

  constructor(
    private loadingCtrl: LoadingController
  ) { }

  async showLoader(message?: string) {
    if(!this.isLoading) {
      this.isLoading = true;
      const msg = message ?? 'Caricamento in corso...';
      return this.presenta(await this.creaSeAncoraAperto(() => this.loadingCtrl.create({
        spinner: 'bubbles',
        message: msg,
        cssClass: 'loader',
        htmlAttributes: { 'aria-label': msg }
      })));
    }
    return new Promise<boolean>((resolve) => resolve(true));
  }

  async startInvisibleLoader() {
    if(!this.isLoading) {
      this.isLoading = true;
      return this.presenta(await this.creaSeAncoraAperto(() => this.loadingCtrl.create({
        spinner: null,
        cssClass: 'invisible-loader',
        showBackdrop: false,
        htmlAttributes: { 'aria-label': 'Caricamento in corso' }
      })));
    }
    return new Promise<boolean>((resolve) => resolve(true));
  }


  hideLoader() {
    // Idempotente e difensivo: `dismiss()` su un loader già chiuso rigetta la Promise
    // (unhandled rejection) → la inghiottiamo. `isLoading`/`loading` sono SEMPRE azzerati,
    // così uno stato sporco non blocca tutti i `showLoader()` successivi dell'app.
    this.generazione++;
    const current = this.loading;
    this.loading = undefined;
    this.isLoading = false;
    void current?.dismiss().catch(() => undefined);
  }

  showLoaderObserve$(message?: string){
    return from(this.showLoader(message));
  }

  showInvisibleLoaderObserve$(){
    return from(this.startInvisibleLoader());
  }

  /** Crea il loader; se nel frattempo è stato chiuso lo rimuove dal DOM senza presentarlo. */
  private async creaSeAncoraAperto(
    crea: () => Promise<HTMLIonLoadingElement>,
  ): Promise<HTMLIonLoadingElement | undefined> {
    const mia = this.generazione;
    const loading = await crea();
    if (mia !== this.generazione) {
      loading.remove();
      return undefined;
    }
    this.loading = loading;
    return loading;
  }

  private presenta(loading: HTMLIonLoadingElement | undefined): Promise<void> {
    return loading ? loading.present() : Promise.resolve();
  }
}
